export default function IconReportsTagClose () {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5820_20001)">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M0.209352 0.209352C0.488488 -0.0697838 0.941056 -0.0697838 1.22019 0.209352L4 2.98916L6.77981 0.209352C7.05894 -0.069784 7.51151 -0.0697838 7.79065 0.209352C8.06978 0.488487 8.06978 0.941056 7.79065 1.22019L5.01084 4L7.79065 6.77981C8.06978 7.05894 8.06978 7.51151 7.79065 7.79065C7.51151 8.06978 7.05894 8.06978 6.77981 7.79065L4 5.01084L1.22019 7.79065C0.941055 8.06978 0.488487 8.06978 0.209352 7.79065C-0.0697839 7.51151 -0.0697839 7.05894 0.209352 6.77981L2.98916 4L0.209352 1.22019C-0.0697835 0.941056 -0.0697834 0.488487 0.209352 0.209352Z"
              fill="#083D76"/>
      </g>
      <defs>
        <clipPath id="clip0_5820_20001">
          <rect width="8" height="8" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
